import React from 'react';
import { Container, Violator } from '@hpstellar/core';
import Typography from '@hpstellar/core/visId/Typography';
import StockIndicator from '../pdp-details/stock-indicator';
import PriceBlock from '../../components-v2/pdp-details/price-block';
import CTA from '../../components-v2/pdp-details/cta';
import Sku from '../../components-v2/pdp-details/sku';
import { ProductTitle } from '../pdp-details/title-section';
import DeliveryMessage from '../pdp-details/pdp-delivery-message';
import ConsumerFinanceWidget from '../../../product/components/consumer-finance-widget';
import { ReviewSection } from '../pdp-details/title-section';
import PriceBlockV2 from '../pdp-details/product-hero-container/price-container';

import './shadow-header.less';

export default ({ pdpShadowCTO, productInitial, bazaarVoiceProps = {}, v2 }) => {
    const { shadowCTOEnabled } = pdpShadowCTO || {};

    if (!shadowCTOEnabled) {
        return null;
    }
    const { shipDate, HPFinance_Promo, enrollmentKit } = productInitial;
    const { overviewAttributes } = productInitial || EMPTY_OBJ;
    const { nextGenTagline } = overviewAttributes || EMPTY_OBJ;

    return (
        <div className={`shadowHeaderContainer${v2 ? ' v2' : ''}`}>
            <Container>
                <div class="shadowHeader">
                    <div className="product-container">
                        {v2 && <ReviewSection productInitial={productInitial} bazaarVoiceProps={bazaarVoiceProps} />}
                        <ProductTitle typographyProps={{ variant: 'titleM' }} />
                        {v2 && nextGenTagline && (
                            <Typography className="title-tagline" variant="caption">
                                {nextGenTagline}
                            </Typography>
                        )}
                        <div className="inventory-row">
                            <StockIndicator
                                stockIndicatorProps={{ size: 'small', messagesOrientation: 'horizontal' }}
                                shipDate={shipDate}
                            />
                            <div className="spacer">{'|'}</div>
                            <Sku />
                        </div>
                    </div>
                    <div className="price-container">
                        <div className={HPFinance_Promo ? 'finance-container' : ''}>
                            {!enrollmentKit && (
                                <>
                                    {v2 ? (
                                        <PriceBlockV2 hasPriceSeoText={false} className="sto-pdp-price-row" />
                                    ) : (
                                        <PriceBlock />
                                    )}
                                </>
                            )}
                            <ConsumerFinanceWidget product={productInitial} />
                        </div>
                        <CTA />
                    </div>
                </div>
            </Container>
        </div>
    );
};
